// extracted by mini-css-extract-plugin
module.exports = {"container":"videoSection-module--container--1kqdE","inner":"videoSection-module--inner--3GbSs","revealed":"videoSection-module--revealed--oETk-"};